import { default as a_45guide_45to_45full_45compliance_45in_45intumescent_45paintcP2IHn12QKMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/a-guide-to-full-compliance-in-intumescent-paint.vue?macro=true";
import { default as a_45review_45of_45intumescent_45paint0vKamklJwMMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/a-review-of-intumescent-paint.vue?macro=true";
import { default as companysaKjnIr7BNMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/about/company.vue?macro=true";
import { default as achieve_452_45hour_45fire_45rating_45over_45drywall_45using_45intumescent_45paintgcHZliyHdfMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/achieve-2-hour-fire-rating-over-drywall-using-intumescent-paint.vue?macro=true";
import { default as applying_45fire_45rated_45intumescent_45paint_45on_45gypsumaADyzYj1EzMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-gypsum.vue?macro=true";
import { default as applying_45fire_45rated_45intumescent_45paint_45on_45steelGLoeJbA7s0Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-steel.vue?macro=true";
import { default as applying_45fire_45rated_45intumescent_45paint_45on_45wood332EkFOGdFMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-wood.vue?macro=true";
import { default as applying_45fire_45retardant_45coatings_45on_45woodqOO2YbGyN5Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-retardant-coatings-on-wood.vue?macro=true";
import { default as applying_45flame_45retardant_45coatings_45on_45fabricsPvqafJ1mWTMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-flame-retardant-coatings-on-fabrics.vue?macro=true";
import { default as articlesfW2KPBbRv5Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/articles.vue?macro=true";
import { default as reset_45passwordJuolzX1vBSMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/auth/reset-password.vue?macro=true";
import { default as building_45with_45fire_45safety_45in_45mind9NlWKSNBTxMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/building-with-fire-safety-in-mind.vue?macro=true";
import { default as cart3KQn2QLYPiMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/cart.vue?macro=true";
import { default as checkoutvznWUdhY5UMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/checkout.vue?macro=true";
import { default as company_45newsI9nX9BpybPMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/company-news.vue?macro=true";
import { default as comprehensive_45guide_45to_45intumescent_45paintJI0wWOIffOMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/comprehensive-guide-to-intumescent-paint.vue?macro=true";
import { default as confirm_45emailuXyt7no6rtMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/confirm-email.vue?macro=true";
import { default as contact_45usqacUYgv2JMMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/contact-us.vue?macro=true";
import { default as infoRyqxdlTHALMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/customer/info.vue?macro=true";
import { default as engineering_45judgment_45importance_45of_45fireproofingLMdWurs1LpMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/engineering-judgment-importance-of-fireproofing.vue?macro=true";
import { default as faqj7yTRyyHSsMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/faq.vue?macro=true";
import { default as finish_45rating_45on_45drywallH5DkuZEwqdMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/finish-rating-on-drywall.vue?macro=true";
import { default as fire_45retardant_45clear_45spraytRu78lg7jpMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/fire-retardant-clear-spray.vue?macro=true";
import { default as fireproofing_45methods_45for_45wood02Q04wKYklMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/fireproofing-methods-for-wood.vue?macro=true";
import { default as flameoff_45fire_45barrier_45paint_45for_45haunted_45housesSeZxU9tMiPMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/flameoff-fire-barrier-paint-for-haunted-houses.vue?macro=true";
import { default as flameoff_45partnershipXd7cNvMQr4Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/flameoff-partnership.vue?macro=true";
import { default as how_45to_45achieve_45a_45higher_45fire_45rating_45on_45gypsum_45metal_45and_45wood_45with_45intumescent_45paintrOtjbf8WSnMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/how-to-achieve-a-higher-fire-rating-on-gypsum-metal-and-wood-with-intumescent-paint.vue?macro=true";
import { default as increasing_45fire_45safety_45on_45upholstered_45furnitureelkGR6HJrYMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/increasing-fire-safety-on-upholstered-furniture.vue?macro=true";
import { default as indexPfe0TXBHHLMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/index.vue?macro=true";
import { default as intumescent_45fire_45resistant_45paintu8ZoPA4ceXMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-fire-resistant-paint.vue?macro=true";
import { default as _2_45hour_45fire_45protection_45on_45steel_45beams_45with_45LformaPhLbMh5QL1Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/2-hour-fire-protection-on-steel-beams-with-Lforma.vue?macro=true";
import { default as ambling_45construction_45group_45atlanta_45georgiakhktSohRKPMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/ambling-construction-group-atlanta-georgia.vue?macro=true";
import { default as amu_45surgeonsjzXhOrlaotMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/amu-surgeons.vue?macro=true";
import { default as arc_45partners_45roswell_45georgiaJVlD7kR4FKMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/arc-partners-roswell-georgia.vue?macro=true";
import { default as bartson_45construction_45atlanta_45georgia7oyejyfMB5Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bartson-construction-atlanta-georgia.vue?macro=true";
import { default as bell_45clark_45nashville_45tnXzU04UccyxMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bell-clark-nashville-tn.vue?macro=true";
import { default as bramble_45theater_451_45hour_45fire_45rated_45cieling_45assemblySzTCoyGAVIMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bramble-theater-1-hour-fire-rated-cieling-assembly.vue?macro=true";
import { default as colon_45eye_45clinicilXycJdsLbMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/colon-eye-clinic.vue?macro=true";
import { default as giland_45townhomes9ePaGABrz0Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/giland-townhomes.vue?macro=true";
import { default as indexG9bpg342SnMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/index.vue?macro=true";
import { default as lenox_45propertiesRTt7KS5WMxMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/lenox-properties.vue?macro=true";
import { default as market_45street_45hotel_45augusta_45georgiaHk12cozhc0Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/market-street-hotel-augusta-georgia.vue?macro=true";
import { default as memorial_45building_45deerfield_45academy_45deerfield_45massachusettscCsnoSYbbvMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/memorial-building-deerfield-academy-deerfield-massachusetts.vue?macro=true";
import { default as sk_45battery_45new_45construction_45fire_45rating_45steelCOnURgzs5qMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/sk-battery-new-construction-fire-rating-steel.vue?macro=true";
import { default as turner_45barnaKkXfRu1dxMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/turner-barn.vue?macro=true";
import { default as urban_45housing_45authorityVNOdLlHgJfMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/urban-housing-authority.vue?macro=true";
import { default as world_45cup_452022_45stadium_45achievs_452_45hour_45fire_45rating_45on_45gypsum25p9CHPg3VMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/world-cup-2022-stadium-achievs-2-hour-fire-rating-on-gypsum.vue?macro=true";
import { default as leedTVqKVkCrdQMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/leed.vue?macro=true";
import { default as loginroYjq0HTOxMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/login.vue?macro=true";
import { default as _91id_93ERkLrpPYB9Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/orderdetails/[id].vue?macro=true";
import { default as our_45certified_45applicatorsexN6d7tM4GMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/our-certified-applicators.vue?macro=true";
import { default as passwordrecoveryD3mxguxT7uMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/passwordrecovery.vue?macro=true";
import { default as privacy_45policyAmcbrKY3oDMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/privacy-policy.vue?macro=true";
import { default as registers9hanbv782Meta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/register.vue?macro=true";
import { default as return_45policyTzSTtEsPyiMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/return-policy.vue?macro=true";
import { default as shipping_45policyQe7b47JQMGMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/shipping-policy.vue?macro=true";
import { default as steel_45coverage_45calculatorj8yWUXDhXcMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/steel-coverage-calculator.vue?macro=true";
import { default as steel_45dimensions_45tableUNrxnPvbwWMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/steel-dimensions-table.vue?macro=true";
import { default as term_45of_45usem2kIEvSJWIMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/term-of-use.vue?macro=true";
import { default as terms_45and_45conditionsoJohczuhfEMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/terms-and-conditions.vue?macro=true";
import { default as terms_45of_45serviceQoFjVFNi0dMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/terms-of-service.vue?macro=true";
import { default as testingSAw3XK8f1OMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/testing.vue?macro=true";
import { default as _91id_93oAqIGC3f6SMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/thankyou/[id].vue?macro=true";
import { default as understanding_45canadian_45standards_45of_45fire_45safetyjmU5Qi7z8TMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/understanding-canadian-standards-of-fire-safety.vue?macro=true";
import { default as when_45fireproofing_45building_45spray_45is_45kingDS1oT7f4qUMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/when-fireproofing-building-spray-is-king.vue?macro=true";
import { default as why_45the_45size_45of_45steel_45is_45important_45in_45fre_45proofingAbT0IH1DgdMeta } from "C:/Projects/HUB/src/PublicSite/client-app/app/pages/why-the-size-of-steel-is-important-in-fre-proofing.vue?macro=true";
export default [
  {
    name: "a-guide-to-full-compliance-in-intumescent-paint",
    path: "/a-guide-to-full-compliance-in-intumescent-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/a-guide-to-full-compliance-in-intumescent-paint.vue")
  },
  {
    name: "a-review-of-intumescent-paint",
    path: "/a-review-of-intumescent-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/a-review-of-intumescent-paint.vue")
  },
  {
    name: "about-company",
    path: "/about/company",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/about/company.vue")
  },
  {
    name: "achieve-2-hour-fire-rating-over-drywall-using-intumescent-paint",
    path: "/achieve-2-hour-fire-rating-over-drywall-using-intumescent-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/achieve-2-hour-fire-rating-over-drywall-using-intumescent-paint.vue")
  },
  {
    name: "applying-fire-rated-intumescent-paint-on-gypsum",
    path: "/applying-fire-rated-intumescent-paint-on-gypsum",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-gypsum.vue")
  },
  {
    name: "applying-fire-rated-intumescent-paint-on-steel",
    path: "/applying-fire-rated-intumescent-paint-on-steel",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-steel.vue")
  },
  {
    name: "applying-fire-rated-intumescent-paint-on-wood",
    path: "/applying-fire-rated-intumescent-paint-on-wood",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-rated-intumescent-paint-on-wood.vue")
  },
  {
    name: "applying-fire-retardant-coatings-on-wood",
    path: "/applying-fire-retardant-coatings-on-wood",
    meta: applying_45fire_45retardant_45coatings_45on_45woodqOO2YbGyN5Meta || {},
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-fire-retardant-coatings-on-wood.vue")
  },
  {
    name: "applying-flame-retardant-coatings-on-fabrics",
    path: "/applying-flame-retardant-coatings-on-fabrics",
    meta: applying_45flame_45retardant_45coatings_45on_45fabricsPvqafJ1mWTMeta || {},
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/applying-flame-retardant-coatings-on-fabrics.vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/articles.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/auth/reset-password.vue")
  },
  {
    name: "building-with-fire-safety-in-mind",
    path: "/building-with-fire-safety-in-mind",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/building-with-fire-safety-in-mind.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/cart.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/checkout.vue")
  },
  {
    name: "company-news",
    path: "/company-news",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/company-news.vue")
  },
  {
    name: "comprehensive-guide-to-intumescent-paint",
    path: "/comprehensive-guide-to-intumescent-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/comprehensive-guide-to-intumescent-paint.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/confirm-email.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/contact-us.vue")
  },
  {
    name: "customer-info",
    path: "/customer/info",
    meta: infoRyqxdlTHALMeta || {},
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/customer/info.vue")
  },
  {
    name: "engineering-judgment-importance-of-fireproofing",
    path: "/engineering-judgment-importance-of-fireproofing",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/engineering-judgment-importance-of-fireproofing.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/faq.vue")
  },
  {
    name: "finish-rating-on-drywall",
    path: "/finish-rating-on-drywall",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/finish-rating-on-drywall.vue")
  },
  {
    name: "fire-retardant-clear-spray",
    path: "/fire-retardant-clear-spray",
    meta: fire_45retardant_45clear_45spraytRu78lg7jpMeta || {},
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/fire-retardant-clear-spray.vue")
  },
  {
    name: "fireproofing-methods-for-wood",
    path: "/fireproofing-methods-for-wood",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/fireproofing-methods-for-wood.vue")
  },
  {
    name: "flameoff-fire-barrier-paint-for-haunted-houses",
    path: "/flameoff-fire-barrier-paint-for-haunted-houses",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/flameoff-fire-barrier-paint-for-haunted-houses.vue")
  },
  {
    name: "flameoff-partnership",
    path: "/flameoff-partnership",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/flameoff-partnership.vue")
  },
  {
    name: "how-to-achieve-a-higher-fire-rating-on-gypsum-metal-and-wood-with-intumescent-paint",
    path: "/how-to-achieve-a-higher-fire-rating-on-gypsum-metal-and-wood-with-intumescent-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/how-to-achieve-a-higher-fire-rating-on-gypsum-metal-and-wood-with-intumescent-paint.vue")
  },
  {
    name: "increasing-fire-safety-on-upholstered-furniture",
    path: "/increasing-fire-safety-on-upholstered-furniture",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/increasing-fire-safety-on-upholstered-furniture.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/index.vue")
  },
  {
    name: "intumescent-fire-resistant-paint",
    path: "/intumescent-fire-resistant-paint",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-fire-resistant-paint.vue")
  },
  {
    name: "intumescent-paint-case-studies-2-hour-fire-protection-on-steel-beams-with-Lforma",
    path: "/intumescent-paint-case-studies/2-hour-fire-protection-on-steel-beams-with-Lforma",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/2-hour-fire-protection-on-steel-beams-with-Lforma.vue")
  },
  {
    name: "intumescent-paint-case-studies-ambling-construction-group-atlanta-georgia",
    path: "/intumescent-paint-case-studies/ambling-construction-group-atlanta-georgia",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/ambling-construction-group-atlanta-georgia.vue")
  },
  {
    name: "intumescent-paint-case-studies-amu-surgeons",
    path: "/intumescent-paint-case-studies/amu-surgeons",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/amu-surgeons.vue")
  },
  {
    name: "intumescent-paint-case-studies-arc-partners-roswell-georgia",
    path: "/intumescent-paint-case-studies/arc-partners-roswell-georgia",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/arc-partners-roswell-georgia.vue")
  },
  {
    name: "intumescent-paint-case-studies-bartson-construction-atlanta-georgia",
    path: "/intumescent-paint-case-studies/bartson-construction-atlanta-georgia",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bartson-construction-atlanta-georgia.vue")
  },
  {
    name: "intumescent-paint-case-studies-bell-clark-nashville-tn",
    path: "/intumescent-paint-case-studies/bell-clark-nashville-tn",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bell-clark-nashville-tn.vue")
  },
  {
    name: "intumescent-paint-case-studies-bramble-theater-1-hour-fire-rated-cieling-assembly",
    path: "/intumescent-paint-case-studies/bramble-theater-1-hour-fire-rated-cieling-assembly",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/bramble-theater-1-hour-fire-rated-cieling-assembly.vue")
  },
  {
    name: "intumescent-paint-case-studies-colon-eye-clinic",
    path: "/intumescent-paint-case-studies/colon-eye-clinic",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/colon-eye-clinic.vue")
  },
  {
    name: "intumescent-paint-case-studies-giland-townhomes",
    path: "/intumescent-paint-case-studies/giland-townhomes",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/giland-townhomes.vue")
  },
  {
    name: "intumescent-paint-case-studies",
    path: "/intumescent-paint-case-studies",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/index.vue")
  },
  {
    name: "intumescent-paint-case-studies-lenox-properties",
    path: "/intumescent-paint-case-studies/lenox-properties",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/lenox-properties.vue")
  },
  {
    name: "intumescent-paint-case-studies-market-street-hotel-augusta-georgia",
    path: "/intumescent-paint-case-studies/market-street-hotel-augusta-georgia",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/market-street-hotel-augusta-georgia.vue")
  },
  {
    name: "intumescent-paint-case-studies-memorial-building-deerfield-academy-deerfield-massachusetts",
    path: "/intumescent-paint-case-studies/memorial-building-deerfield-academy-deerfield-massachusetts",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/memorial-building-deerfield-academy-deerfield-massachusetts.vue")
  },
  {
    name: "intumescent-paint-case-studies-sk-battery-new-construction-fire-rating-steel",
    path: "/intumescent-paint-case-studies/sk-battery-new-construction-fire-rating-steel",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/sk-battery-new-construction-fire-rating-steel.vue")
  },
  {
    name: "intumescent-paint-case-studies-turner-barn",
    path: "/intumescent-paint-case-studies/turner-barn",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/turner-barn.vue")
  },
  {
    name: "intumescent-paint-case-studies-urban-housing-authority",
    path: "/intumescent-paint-case-studies/urban-housing-authority",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/urban-housing-authority.vue")
  },
  {
    name: "intumescent-paint-case-studies-world-cup-2022-stadium-achievs-2-hour-fire-rating-on-gypsum",
    path: "/intumescent-paint-case-studies/world-cup-2022-stadium-achievs-2-hour-fire-rating-on-gypsum",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/intumescent-paint-case-studies/world-cup-2022-stadium-achievs-2-hour-fire-rating-on-gypsum.vue")
  },
  {
    name: "leed",
    path: "/leed",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/leed.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/login.vue")
  },
  {
    name: "orderdetails-id",
    path: "/orderdetails/:id()",
    meta: _91id_93ERkLrpPYB9Meta || {},
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/orderdetails/[id].vue")
  },
  {
    name: "our-certified-applicators",
    path: "/our-certified-applicators",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/our-certified-applicators.vue")
  },
  {
    name: "passwordrecovery",
    path: "/passwordrecovery",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/passwordrecovery.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/privacy-policy.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/register.vue")
  },
  {
    name: "return-policy",
    path: "/return-policy",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/return-policy.vue")
  },
  {
    name: "shipping-policy",
    path: "/shipping-policy",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/shipping-policy.vue")
  },
  {
    name: "steel-coverage-calculator",
    path: "/steel-coverage-calculator",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/steel-coverage-calculator.vue")
  },
  {
    name: "steel-dimensions-table",
    path: "/steel-dimensions-table",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/steel-dimensions-table.vue")
  },
  {
    name: "term-of-use",
    path: "/term-of-use",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/term-of-use.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-of-service",
    path: "/terms-of-service",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/terms-of-service.vue")
  },
  {
    name: "testing",
    path: "/testing",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/testing.vue")
  },
  {
    name: "thankyou-id",
    path: "/thankyou/:id()",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/thankyou/[id].vue")
  },
  {
    name: "understanding-canadian-standards-of-fire-safety",
    path: "/understanding-canadian-standards-of-fire-safety",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/understanding-canadian-standards-of-fire-safety.vue")
  },
  {
    name: "when-fireproofing-building-spray-is-king",
    path: "/when-fireproofing-building-spray-is-king",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/when-fireproofing-building-spray-is-king.vue")
  },
  {
    name: "why-the-size-of-steel-is-important-in-fre-proofing",
    path: "/why-the-size-of-steel-is-important-in-fre-proofing",
    component: () => import("C:/Projects/HUB/src/PublicSite/client-app/app/pages/why-the-size-of-steel-is-important-in-fre-proofing.vue")
  }
]